import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, map } from 'rxjs/operators'


@Injectable({
  providedIn: 'root'
})


export class LoginService {
  constructor(
    private http: HttpClient,
  ) { }

  GetCredentials(DomainDetail: any) {
    return this.http.post<any>(environment.API_URL_Main + `GetCredentials`,
      DomainDetail
    ).pipe(map(response => {
      return response;
    }));
  }

  Auth(UserDetail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `Auth`,
      UserDetail
    ).pipe(map(response => {
      return response;
    }));
  }

  LoginCheck(UserDetail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `LoginCheck/LoginCheck`,
      UserDetail
    ).pipe(map(response => {
      return response;
    }));
  }

  GetCompany(UserDetail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `CompanySelection/GetCompany`,
      UserDetail
    ).pipe(map(response => {
      return response;
    }));
  }

  GenerateOTP(OTPDetail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `Login/GenerateOTP`,
      OTPDetail
    ).pipe(map(response => {
      return response;
    }));
  }

  SaveForgotPassword(OTPDetail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `ForgotPassword/Set`,
      OTPDetail
    ).pipe(map(response => {
      return response;
    }));
  }

  DbNameWithSessionInsret(Detail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `DbNameWithSession/Insret`,
      Detail
    ).pipe(map(response => {
      return response;
    }));
  }

  Ess_Link_ExpiryCheck(Detail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `Ess_Link_Expiry/Check`,
      Detail
    ).pipe(map(response => {
      return response;
    }));
  }

  ESS_GetLoginDetails(Detail: any, ApiUrl: String) {
    return this.http.post<any>(ApiUrl + `ESS_GetLogin/Details`,
      Detail
    ).pipe(map(response => {
      return response;
    }));
  }
}